<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.32989 1.89066C3.32989 2.69436 2.66756 3.34589 1.85053 3.34589C1.03343 3.34589 0.371094 2.69436 0.371094 1.89066C0.371094 1.08696 1.03343 0.435425 1.85053 0.435425C2.66756 0.435425 3.32989 1.08696 3.32989 1.89066Z"
      fill="#575757"
    />
    <path
      d="M14.8917 3.34588H6.6859C5.86887 3.34588 5.20654 2.69436 5.20654 1.89066C5.20654 1.08697 5.86887 0.435445 6.6859 0.435445H14.8917C15.7087 0.435445 16.3711 1.08697 16.3711 1.89066C16.3711 2.69436 15.7087 3.34588 14.8917 3.34588Z"
      fill="#575757"
    />
    <path
      d="M14.8917 5.48021H6.6859C5.86887 5.48021 5.20654 6.13173 5.20654 6.93542C5.20654 7.73912 5.86887 8.39064 6.6859 8.39064H14.8917C15.7087 8.39064 16.3711 7.73912 16.3711 6.93542C16.3711 6.13173 15.7087 5.48021 14.8917 5.48021Z"
      fill="#575757"
    />
    <path
      d="M3.32989 6.93542C3.32989 7.73913 2.66756 8.39066 1.85053 8.39066C1.03343 8.39066 0.371094 7.73913 0.371094 6.93542C0.371094 6.13172 1.03343 5.48019 1.85053 5.48019C2.66756 5.48019 3.32989 6.13172 3.32989 6.93542Z"
      fill="#575757"
    />
    <path
      d="M14.8917 10.525H6.6859C5.86887 10.525 5.20654 11.1765 5.20654 11.9802C5.20654 12.7839 5.86887 13.4354 6.6859 13.4354H14.8917C15.7087 13.4354 16.3711 12.7839 16.3711 11.9802C16.3711 11.1765 15.7087 10.525 14.8917 10.525Z"
      fill="#575757"
    />
    <path
      d="M3.32989 11.9802C3.32989 12.7839 2.66756 13.4354 1.85053 13.4354C1.03343 13.4354 0.371094 12.7839 0.371094 11.9802C0.371094 11.1765 1.03343 10.525 1.85053 10.525C2.66756 10.525 3.32989 11.1765 3.32989 11.9802Z"
      fill="#575757"
    />
  </svg>
</template>
